export const dimensions = {
  marginBigger: '48px',
  marginBig: '24px',
  marginMedium: '20px',
  marginSmallMedium: '16px',
  marginSmall: '12px',
  marginTiny: '5px',
  mainHeaderHeight: '56px',
  sideNavWidth: '240px',
  borderRadius: '4px',
};

export default dimensions;
